import { LoginResponse } from '../login/login.types'

export interface LoginViaIntermediateTokenRequest {
  intermediate_token: string
}

export interface LoginViaIntermediateTokenResponse extends LoginResponse {}
